import React from 'react';
import PolicyPage from '../../components/PolicyPage';

const Terms: React.FC = () => (
  <PolicyPage slug="terms" subtitle="Terms & Conditions" />
);

export default Terms;
